import { render, staticRenderFns } from "./DbuggaTool.vue?vue&type=template&id=35024fd8&scoped=true"
import script from "./DbuggaTool.vue?vue&type=script&lang=js"
export * from "./DbuggaTool.vue?vue&type=script&lang=js"
import style0 from "./DbuggaTool.vue?vue&type=style&index=0&id=35024fd8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35024fd8",
  null
  
)

export default component.exports